import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MaterialIcon from '../../../../components/MaterialIcon/MaterialIcon';
import styles from './MeterkastScheduledContent.module.scss';

const MeterkastScheduledContent: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.iconWrap}>
        <MaterialIcon name="check_circle" size={64} />
      </div>

      <h2 className={styles.title}>{t('meterkast:scheduledTitle')}</h2>
      <p className={styles.body}>{t('meterkast:scheduledBody')}</p>
    </>
  );
};

export default MeterkastScheduledContent;
